import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useCallback } from "react";
import Box from "../Box";
import Input from "../Input";
import Button from "../Button";
import Card from "../Card";
import Label from "../Label";
import { BubbleIcon } from "../Icons";
import RequiredAsterisk from "../RequiredAsterisk";
var sanitizeFormData = function (data) {
    return {
        firstName: data.firstName.trim(),
        lastName: data.lastName.trim(),
        email: data.email.toLowerCase().trim(),
    };
};
var PreChatForm = function (props) {
    var _a = useState(""), firstName = _a[0], setFirstName = _a[1];
    var _b = useState(""), lastName = _b[0], setLastName = _b[1];
    var _c = useState(""), email = _c[0], setEmail = _c[1];
    var onSubmit = useCallback(function (e) {
        e.preventDefault();
        var formData = sanitizeFormData({
            firstName: firstName,
            lastName: lastName,
            email: email,
        });
        props.onSubmit(formData);
    }, [props, firstName, lastName, email]);
    return (_jsx(Box, { col: true, width: "100%", maxWidth: props.width, maxHeight: props.height, justifyContent: "flex-end", alignItems: "flex-end", children: _jsx(Card, { title: props.uiLabels.preChatFormTitle, emoji: _jsx(BubbleIcon, { color: "var(--text-color)", width: "1.2em", height: "1.2em" }), onClose: props.onClose, children: _jsx("form", { onSubmit: onSubmit, children: _jsxs(Box, { col: true, width: "100%", gap: "1em", padding: ".5em", children: [_jsxs(Box, { row: true, gap: "1em", center: true, width: "100%", children: [_jsxs(Box, { col: true, width: "100%", children: [_jsxs(Label, { htmlFor: "first-name", children: ["First Name ", _jsx(RequiredAsterisk, {})] }), _jsx(Input, { id: "first-name", ariaLabel: "First Name", placeholder: "First Name", value: firstName, onChange: setFirstName, required: true })] }), _jsxs(Box, { col: true, width: "100%", children: [_jsxs(Label, { htmlFor: "last-name", children: ["Last Name ", _jsx(RequiredAsterisk, {})] }), _jsx(Input, { id: "last-name", ariaLabel: "Last Name", placeholder: "Last Name", value: lastName, onChange: setLastName, required: true })] })] }), _jsxs(Box, { col: true, width: "100%", children: [_jsxs(Label, { htmlFor: "email", children: ["Email ", _jsx(RequiredAsterisk, {})] }), _jsx(Input, { id: "email", ariaLabel: "Email Address", placeholder: "Email Address", value: email, type: "email", onChange: setEmail, pattern: "[^@\\s]+@[^@\\s]+\\.[^@\\s]+", required: true })] }), _jsx(Box, { row: true, width: "100%", padding: ".5em", center: true, children: _jsx(Button, { type: "submit", ariaLabel: "Start Chat", onClick: function () {
                                    window.dataLayer = window.dataLayer || [];
                                    var eventData = {
                                        event: "gtm-chatbot-begin-chat",
                                        session_id: new Date().getTime(),
                                        requestStatus: "gtm-chatbot-begin-chat",
                                    };
                                    window.dataLayer.push(eventData);
                                }, children: props.uiLabels.preChatButtonLabel }) })] }) }) }) }));
};
export default PreChatForm;
